var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{class:{ dark: _vm.dark, light: _vm.light },attrs:{"viewBox":"0 0 59 78"}},[_c('path',{staticClass:"file_cover",attrs:{"d":"M0 78H58.9989V14L45 0H0V78Z"}}),_c('path',{staticClass:"file_corner",attrs:{"d":"M45 14L59 14L45 0V14Z"}})])}
var staticRenderFns = []

export { render, staticRenderFns }